import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/pro-solid-svg-icons';

import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';
import ProjectCard from 'components/project/project_card';
import PredictionSummary from './prediction_summary';

export class ListingPrediction extends React.Component {
  static propTypes = {
    editLink: PropTypes.string,
    features: PropTypes.shape({
      backoffice: PropTypes.bool,
      pipeline: PropTypes.bool,
    }).isRequired,
    history: PropTypes.object.isRequired,
    listing: PropTypes.shape({
      daysLikelyToClose: PropTypes.number,
      estimatedGrossCommission: PropTypes.number,
      listingStatus: PropTypes.string.isRequired,
      percentageLikelyToClose: PropTypes.number,
      typeLabel: PropTypes.string.isRequired
    }),
    moveToTab: PropTypes.func,
    showUpdateModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  };

  goToVoucherTab = (e) => {
    if (e) e.preventDefault();

    this.props.history.push('/vouchers');
  }

  predictionCardAction() {
    const { editLink, features, listing, moveToTab, showUpdateModal } = this.props;
    const { backoffice, pipeline } = features;
    const closed = listing.listingStatus === 'closed';

    const items = [];
    if (backoffice && (!closed || moveToTab)) {
      items.push(
        <MenuItem key="vouchers-tab" name="go-to-vouchers" onClick={this.goToVoucherTab}>Go To Vouchers</MenuItem>
      );
    }
    if ((backoffice && !closed) || pipeline) {
      items.push(
        <MenuItem key="modal" name="update-prediction-link" onClick={showUpdateModal}>
          Update{closed ? '' : ' Prediction'}
        </MenuItem>
      );
    }

    items.push(
      <MenuItem href={`${editLink}#saleFields`} key="edit-link" name="edit-listing-link">
        Edit {listing.typeLabel}
      </MenuItem>
    );

    return (
      <Dropdown dropup={true} id={`listing-menu-${listing.id}`}>
        <UnstyledDropdownToggle bsRole="toggle" id={`listing-button-${listing.id}`} variant="dark">
          <FontAwesomeIcon className="space-settings" icon={faCog} size="lg" />
        </UnstyledDropdownToggle>

        <Dropdown.Menu className="dropdown-menu-right">
          {items}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  render() {
    return (
      <ProjectCard bare name={this.props.title} rightActions={[this.predictionCardAction()]} wrapBody>
        <PredictionSummary {...this.props.listing} />
      </ProjectCard>
    );
  }
}

export default withRouter(ListingPrediction);
